// The words of the question "Study now" asks before it makes a line (components/chrome/StudyChoice.tsx).
import { words } from "../services/i18n.ts";

export const t = words({
    en: {
        title: "Study this line",
        once: "Study once",
        onceNote: "Practise it now. It is not added to your lines.",
        keep: "Add to my lines and study",
        keepNote: "It stays in My lines, to come back to.",
        cancel: "Cancel",
    },
    es: {
        title: "Estudiar esta línea",
        once: "Estudiar una vez",
        onceNote: "Practícala ahora. No se añade a tus líneas.",
        keep: "Añadir a mis líneas y estudiar",
        keepNote: "Se queda en Mis líneas para volver a ella.",
        cancel: "Cancelar",
    },
});
